import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MainNavbarComponent } from '../../../../core/components/main-navbar/main-navbar.component';
import { Store } from '@ngrx/store';
import { submitSearch } from '../../../../state/action';
import { ThematicService } from '../../services/thematic.service';

@Component({
  selector: 'app-custom-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MainNavbarComponent],
  templateUrl: './custom-search.component.html',
  styleUrl: './custom-search.component.css'
})
export class CustomSearchComponent {
  constructor(private store: Store, private thematicService: ThematicService
  ) {

  }
  custom_query = new FormControl<string>("");
  advanced_query = new FormControl<string>("");
  searchtype: string = 'advanced';
  isGenerating = false;
  ngOnInit() {

  }
  onSearchTypeToggle(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchtype = inputElement.checked ? 'advanced' : 'normal';
  }


  searchTheme(searchtype: string) {
    if (this.isGenerating) return;
    const isNormal = searchtype === 'normal';
    const apiQuery = isNormal ? `ftxt="${this.custom_query.value}"` : this.advanced_query.value;

    this.isGenerating = true;
    this.thematicService.generateAITheme(apiQuery!).subscribe({
      next: res => {
        const name = res.payload?.name?.trim() || "Custom Theme";
        this.dispatchSearch(apiQuery!, name);
      },
      error: () => this.dispatchSearch(apiQuery!, "Custom Theme"),
    });
  }

  private dispatchSearch(apiQuery: string, name: string) {
    this.isGenerating=false;
    this.store.dispatch(submitSearch({
      searchParams: {
        themes: [{ api_query: apiQuery, name, theme_search_type: 'custom', cluster_id: null, cluster_name: null }]
      },
      searchType: 'theme'
    }));
  }


}
